import React from "react";

import { MediaChooserBlock as Value } from "@reactivated";

import { injectComponents } from "../../utils/injection";
import { ImageChooserBlock } from "../ImageChooserBlock";
import { StreamField, StreamFieldBlockMap } from "../StreamField";
import { VideoChooserBlock } from "../VideoChooserBlock";
import { MediaEmbedBlock } from "./MediaEmbedBlock";

const dependencies = {
    ImageChooserBlock,
    VideoChooserBlock,
    MediaEmbedBlock,
} as const;

export const MediaChooserBlock = injectComponents(dependencies)<{
    value: Value;
    attrs?: React.HTMLAttributes<HTMLElement>;
}>((props) => {
    const { ImageChooserBlock, VideoChooserBlock, MediaEmbedBlock } =
        props.dependencies;
    const components: StreamFieldBlockMap<Value> = {
        image: ImageChooserBlock,
        video: VideoChooserBlock,
        embed: MediaEmbedBlock,
    };
    return (
        <StreamField
            components={components}
            value={props.value}
            tagName={React.Fragment}
        />
    );
});
